export const testimonials = [
  {
    id: "1",
    name: "Sarah Mitchell",
    role: "CEO at Horizon Tech",
    avatar: "SM",
    avatarColor: "bg-primary-100 text-primary-700",
    quote: "Switching to this service was the best decision we made. The 24/7 support alone has saved us countless hours of downtime.",
  },
  {
    id: "2",
    name: "James Rodriguez",
    role: "Operations Director at ScaleUp Inc",
    avatar: "JR",
    avatarColor: "bg-accent-100 text-accent-700",
    quote: "The transparent pricing and custom solutions fit our exact needs. We finally have a partner who understands our business.",
  },
  {
    id: "3",
    name: "Emily Chen",
    role: "Founder at BrightWave",
    avatar: "EC",
    avatarColor: "bg-secondary-100 text-secondary-700",
    quote: "Their fast turnaround is no joke. We have cut our project delivery time by 35% since partnering with them.",
  },
  {
    id: "4",
    name: "Michael Torres",
    role: "CTO at DataFlow Systems",
    avatar: "MT",
    avatarColor: "bg-primary-100 text-primary-700",
    quote: "Data security was our top concern. Their enterprise-grade compliance gave us the confidence to move our entire infrastructure.",
  },
  {
    id: "5",
    name: "Lisa Park",
    role: "VP Marketing at GrowthLab",
    avatar: "LP",
    avatarColor: "bg-accent-100 text-accent-700",
    quote: "The satisfaction guarantee is not just marketing speak. They genuinely went above and beyond when we needed adjustments.",
  },
  {
    id: "6",
    name: "David Kim",
    role: "Head of Product at Nexus",
    avatar: "DK",
    avatarColor: "bg-secondary-100 text-secondary-700",
    quote: "Scalable plans meant we could start with what we needed and grow as our user base expanded. Seamless transition.",
  },
];